import React from 'react';
import './color-picker.scss';

const ColorPicker = props => {
    return (
        <div className="color-picker">
            <div className="color-picker__color" style={{ backgroundColor: props.color }}></div>
            <input type="text" 
                    className="color-picker__input"
                    value={props.textColor} 
                    maxLength="7"
                    onChange={(e) => props.onChange(e)} />
            <label className="color-picker__picker" 
                    htmlFor="districtcolor">
                <input type="color" 
                        onChange={(e) => props.handleInputColorChange(e)}
                        id="districtcolor" 
                        name="districtcolor" 
                        value={props.color} />
            </label>
        </div>
    );
};

export default ColorPicker;